import React from "react";

const InlineNoticeLabel = ({ style, label, ...rest }, { muiTheme }) => {
  const STYLE = {
    color: "#fff",
    backgroundColor: muiTheme.palette.primary1Color,
    textTransform: "uppercase",
    padding: "3px 5px",
    fontSize: 10,
    verticalAlign: "top",
    borderRadius: 3
  };

  return (
    <span {...rest} style={Object.assign({}, STYLE, style)}>
      {label}
    </span>
  );
};

InlineNoticeLabel.contextTypes = { muiTheme: React.PropTypes.object };

export default InlineNoticeLabel;



// WEBPACK FOOTER //
// ./src/app/components/partials/inline-notice-label.jsx